import { useContext } from 'react';
import type { SpLogicCounterpartiesApi } from '@sp-api/counterparties-api';
import ApiContext from '../components/ApiProvider/ApiContext';

export default function useCounterpartiesApiClient(): SpLogicCounterpartiesApi {
  const { counterpartiesApi } = useContext(ApiContext);

  return counterpartiesApi;
}
